import React, { useContext, useCallback, useEffect, useState, useRef } from "react";
import { DContext } from "../../context/Datacontext";
import { FaFileExcel } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { Loader } from "../blocks/Layout/Loader";



export const ConsolidatedReports = () => {
    const { BeURL } = useContext(DContext);
    const navigate = useNavigate()

    const [recruiter, setRecruiter] = useState([]);
    const [recruiterId, setRecruiterId] = useState("");
    const [data, setData] = useState([]);
    const [status, setStatus] = useState([]);
    const tableRef = useRef(null);
    // const [client, setClient] = useState([]);
    // const [spoc, setSpoc] = useState([]);
    // const [spocId, setSpocId] = useState("")
    // const [clintId,setClientId]=useState("")
    const [position, setPosition] = useState("")
    const [searchPosition, setSearchPosition] = useState("");
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")
    const [searchFromDate, setSearchFromDate] = useState("");
    const [searchToDate, setSearchToDate] = useState("");

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);


    const fetchStatus = useCallback(async () => {
        try {
            const response = await fetch(`${BeURL}/allStatus`, {
                method: "GET",
                credentials: "include",
            });
            const result = await response.json();
            if (result.success) {
                setStatus(result.status);
            } else {
                console.log(result.message);
            }
        } catch (err) {
            console.log("Error fetching status:", err);
        }
    }, [BeURL]);

    useEffect(() => {
        fetchStatus();
    }, [fetchStatus]);


    const fetchUser = useCallback(async () => {
        try {
            const response = await fetch(`${BeURL}/fetch-users`, {
                method: "GET",
                credentials: "include",
            });
            const result = await response.json();
            if (result.success) {
                setRecruiter(result.recruiter);
            } else {
                console.log(result.message);
            }
        } catch (err) {
            console.log("Error fetching users:", err);
        }
    }, [BeURL]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);


    const fetchData = useCallback(async () => {
        setLoading(true);

        try {
            const query = new URLSearchParams();

            if (recruiterId) {
                query.append("recruiterId", recruiterId);
            }

            if (searchPosition.trim()) {
                query.append("position", searchPosition);
            }


            if (searchFromDate) {
                query.append("fromDate", searchFromDate);
            }

            if (searchToDate) {
                query.append("toDate", searchToDate);
            }

            query.append("page", page);
            query.append("limit", limit);

            const response = await fetch(
                `${BeURL}/reports/consolidated-reports?${query.toString()}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();
            setData(result);
        } catch (err) {
            console.log("Error fetching data:", err);
        }
        finally {
            setLoading(false);
        }
    }, [BeURL, recruiterId, searchPosition, searchFromDate, searchToDate, , page, limit]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);


    // const fetchSpocs = useCallback(async () => {
    //     try {
    //         const response = await fetch(`${BeURL}/fetch-spocs`, {
    //             method: "GET",
    //             credentials: "include", // Send cookies with the request
    //         });

    //         const data = await response.json();

    //         if (data.success) {
    //             setSpoc(data.spocs);
    //             setClient(data.clients)
    //         } else {
    //             alert(data.message);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         alert("Failed to fetch SPOCs");
    //     }
    // }, [BeURL]);

    // useEffect(() => {
    //     fetchSpocs();
    // }, [fetchSpocs]);



    useEffect(() => {
        const slider = tableRef.current;

        let isDown = false;
        let startX;
        let scrollLeft;

        const mouseDown = (e) => {
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            slider.style.cursor = "grabbing";
        };

        const mouseLeave = () => {
            isDown = false;
            slider.style.cursor = "grab";
        };

        const mouseUp = () => {
            isDown = false;
            slider.style.cursor = "grab";
        };

        const mouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            slider.scrollLeft = scrollLeft - walk;
        };

        slider.addEventListener("mousedown", mouseDown);
        slider.addEventListener("mouseleave", mouseLeave);
        slider.addEventListener("mouseup", mouseUp);
        slider.addEventListener("mousemove", mouseMove);

        return () => {
            slider.removeEventListener("mousedown", mouseDown);
            slider.removeEventListener("mouseleave", mouseLeave);
            slider.removeEventListener("mouseup", mouseUp);
            slider.removeEventListener("mousemove", mouseMove);
        };
    }, []);



    const downloadExcel = async () => {
        setLoading(true)
        try {

            const query = new URLSearchParams();

            if (recruiterId) {
                query.append("recruiterId", recruiterId);
            }

            if (position) {
                query.append("position", position);
            }

            if(fromDate){
                query.append("fromDate" , fromDate)
            }

            if(toDate){
                query.append("toDate", toDate)
            }

            const response = await fetch(
                `${BeURL}/download-consolidated-report?${query.toString()}`
            );

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");

            a.href = url;
            a.download = "Consolidated_Report.xlsx";

            document.body.appendChild(a);

            a.click();

            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };


    const handleViewPositionProfiles = (jobId) => {
        // navigate(`/candidate-profile/${jobId}`)
        navigate(`/recuriter-status/${jobId}?from=${fromDate}&to=${toDate}`)
    }


    const groupColors = {
        "Screening": "bg-yellow-500",
        "Level 1 Interview": "bg-green-600",
        "Level 2 Interview": "bg-yellow-500",
        "Level 3 Interview": "bg-purple-600",
        "Client Round": "bg-pink-600",
        "BGV": "bg-indigo-600",
        "Offer Status": "bg-green-600",
        "Drop": "bg-red-600",
    };


    const groupedStatus = status.reduce((acc, item) => {
        if (!acc[item.group]) {
            acc[item.group] = [];
        }
        acc[item.group].push(item);
        return acc;
    }, {});


    const totalPages = data?.pagination?.totalPages || 1;



    const getPageNumbers = () => {
        const delta = 2;
        const range = [];
        const pages = [];

        range.push(1);

        for (
            let i = Math.max(2, page - delta);
            i <= Math.min(totalPages - 1, page + delta);
            i++
        ) {
            range.push(i);
        }

        if (totalPages > 1) {
            range.push(totalPages);
        }

        const uniqueRange = [...new Set(range)].sort((a, b) => a - b);

        let last = 0;

        uniqueRange.forEach((item) => {
            if (last) {
                if (item - last === 2) {
                    pages.push(last + 1);
                } else if (item - last > 2) {
                    pages.push("...");
                }
            }

            pages.push(item);
            last = item;
        });

        return pages;
    };


    const startRecord =
        data?.pagination?.total === 0
            ? 0
            : (page - 1) * limit + 1;

    const endRecord = Math.min(
        page * limit,
        data?.pagination?.total || 0
    );


    const goToFirst = () => {
        if (page > 1) {
            setPage(1);
        }
    };

    const goToPrevious = () => {
        if (page > 1) {
            setPage((prev) => prev - 1);
        }
    };

    const goToNext = () => {
        if (page < totalPages) {
            setPage((prev) => prev + 1);
        }
    };

    const goToLast = () => {
        if (page < totalPages) {
            setPage(totalPages);
        }
    };


    useEffect(() => {
        if (tableRef.current) {
            tableRef.current.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [page]);


    return (
        <div className="min-h-screen  p-6">
            <div className="mx-auto">
                {/* Table Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">

                    {/* <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-gray-800">
                            Consolidated Reports
                        </h2>
                        <div>
                            <div>
                                <div>
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        className="border rounded-lg px-3 py-2"
                                    />

                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        className="border rounded-lg px-3 py-2"
                                    />
                                    <button
                                        onClick={() => {
                                            setPage(1);
                                            setSearchPosition(position);
                                            setSearchFromDate(fromDate);
                                            setSearchToDate(toDate);
                                        }}
                                    >
                                        Find
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={downloadExcel}
                            className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-green-700 active:scale-95 transition-all duration-200"
                        >
                            <FaFileExcel />
                            Download
                        </button>
                    </div> */}

                    <div className="px-6 py-4 border-b border-gray-200 bg-white">
                        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">

                            {/* Title */}
                            <div>
                                <h2 className="text-xl font-bold text-gray-800">
                                    Consolidated Reports
                                </h2>
                                <p className="text-sm text-gray-500 mt-1">
                                    Filter reports by submission date and export to Excel.
                                </p>
                            </div>

                            {/* Filters & Actions */}
                            <div className="flex flex-wrap items-end gap-3">

                                {/* From Date */}
                                <div className="flex flex-col">
                                    <label className="text-xs font-medium text-gray-500 mb-1">
                                        From
                                    </label>
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        className="h-11 rounded-lg border border-gray-300 px-3 text-sm focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none"
                                    />
                                </div>

                                {/* To Date */}
                                <div className="flex flex-col">
                                    <label className="text-xs font-medium text-gray-500 mb-1">
                                        To
                                    </label>
                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        className="h-11 rounded-lg border border-gray-300 px-3 text-sm focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none"
                                    />
                                </div>

                                {/* Find Button */}
                                <button
                                    onClick={() => {
                                        setPage(1);
                                        setSearchPosition(position);
                                        setSearchFromDate(fromDate);
                                        setSearchToDate(toDate);
                                    }}
                                    className="h-11 px-5 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700 active:scale-95 transition"
                                >
                                    Find
                                </button>

                                {/* Clear */}
                                <button
                                    onClick={() => {
                                        setFromDate("");
                                        setToDate("");
                                        setSearchFromDate("");
                                        setSearchToDate("");
                                        setPage(1);
                                    }}
                                    className="h-11 px-5 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 transition"
                                >
                                    Clear
                                </button>

                                {/* Download */}
                                <button
                                    onClick={downloadExcel}
                                    className="h-11 px-5 rounded-lg bg-green-600 text-white font-medium flex items-center gap-2 hover:bg-green-700 active:scale-95 transition"
                                >
                                    <FaFileExcel />
                                    Download
                                </button>

                            </div>

                        </div>
                    </div>


                    <div ref={tableRef} className="overflow-auto max-h-[700px] cursor-grab">
                        {loading && (
                            <Loader />
                        )}
                        <table className="">
                            <thead className="sticky top-0 z-50 text-xs">

                                {/* Row 1 - Fixed Columns + Group Header */}
                                <tr>
                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">#</th>

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Recruiter
                                    </th>

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Client
                                    </th>

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Client SPOC
                                    </th>

                                    <th rowSpan={2} className="sticky left-0 z-40 bg-primary-500 text-white px-5 py-4 min-w-[250px]">
                                        Position
                                    </th>

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Submitted
                                    </th>

                                    {Object.entries(groupedStatus).map(([group, items]) => (
                                        <th
                                            key={group}
                                            colSpan={items.length}
                                            className={`border text-white text-center ${groupColors[group] || "bg-gray-600"
                                                }`}
                                        >
                                            {group}
                                        </th>
                                    ))}

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Total
                                    </th>

                                    <th rowSpan={2} className="px-5 py-4 border bg-primary-500 text-white">
                                        Difference
                                    </th>
                                </tr>

                                {/* Row 2 - Status Header */}
                                <tr>
                                    {Object.values(groupedStatus).flat().map((item) => (
                                        <th
                                            key={item._id}
                                            className="border bg-primary-500 text-white px-4  whitespace-nowrap"
                                        >
                                            {item.status}
                                        </th>
                                    ))}
                                </tr>

                                {/* Row 3 - Filters */}
                                <tr className="bg-gray-100">

                                    <th></th>

                                    <th className="px-2 py-2">
                                        <select
                                            value={recruiterId}
                                            onChange={(e) => {
                                                setRecruiterId(e.target.value);
                                                setPage(1);
                                            }}
                                            className="w-52 rounded border px-2 py-2"
                                        >
                                            <option value="">All Recruiters</option>

                                            {recruiter.map((rec) => (
                                                <option key={rec._id} value={rec.id}>
                                                    {rec.fullName}
                                                </option>
                                            ))}
                                        </select>
                                    </th>

                                    <th className="px-2 py-2">
                                        {/* <select
                                            value={clintId}
                                            onChange={(e) => setClientId(e.target.value)}
                                            className="w-52 rounded border px-2 py-2"
                                        >
                                            <option value="">All Clients</option>

                                            {client.map((item) => (
                                                <option key={item._id} value={item._id}>
                                                    {item.clientName}
                                                </option>
                                            ))}
                                        </select> */}
                                    </th>

                                    <th className="px-2 py-2">
                                        {/* <select
                                            value={spocId}
                                            onChange={(e) => setSpocId(e.target.value)}
                                            className="w-52 rounded border px-2 py-2"
                                        >
                                            <option value="">All SPOCs</option>

                                            {spoc.map((item) => (
                                                <option key={item._id} value={item._id}>
                                                    {item.fullName}
                                                </option>
                                            ))}
                                        </select> */}
                                    </th>

                                    <th className="sticky left-0 z-30 bg-white px-5 py-4 border min-w-[250px]">
                                        <div className="flex items-center gap-2">
                                            <div className="relative">
                                                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                                <input
                                                    type="text"
                                                    value={position}
                                                    onChange={(e) => setPosition(e.target.value)}
                                                    placeholder="Search Position..."
                                                    className="pl-10 pr-3 py-2 w-64 border border-gray-300 rounded-lg"
                                                />
                                            </div>

                                            <button
                                                onClick={() => {
                                                    setPage(1);
                                                    setSearchPosition(position);
                                                }}
                                                disabled={loading}
                                                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white transition ${loading
                                                    ? "bg-primary-400 cursor-not-allowed"
                                                    : "bg-primary-600 "
                                                    }`}
                                            >
                                                <FiSearch size={16} />
                                                {loading ? "Finding..." : "Find"}
                                            </button>
                                        </div>
                                    </th>
                                    <th></th>

                                    {Object.values(groupedStatus).flat().map((item) => (
                                        <th key={item._id}></th>
                                    ))}

                                    <th></th>
                                    <th></th>
                                </tr>

                            </thead>

                            <tbody>
                                {data?.jobsReports?.length > 0 ? (
                                    data.jobsReports.map((item, index) => (
                                        <tr
                                            key={item._id}
                                            className="border-b hover:bg-blue-50 transition"
                                        >
                                            <td className="px-5 py-4 border">
                                                {(page - 1) * limit + index + 1}
                                            </td>

                                            <td className="px-5 py-4 font-medium text-gray-700 border">
                                                {item.primaryRecruiter?.name}
                                            </td>

                                            <td className="px-5 py-4 border">
                                                {item.client?.name}
                                            </td>

                                            <td className="px-5 py-4 border">
                                                {item.spoc?.name}
                                            </td>
                                            <td className="sticky left-0 z-30 bg-white px-5 py-4 border min-w-[250px]">
                                                <div className="flex items-center gap-3">
                                                    <button
                                                        type="button"
                                                        onClick={() => handleViewPositionProfiles(item._id)}
                                                        className="text-blue-600 hover:text-blue-800 cursor-pointer"
                                                    >
                                                        <FaExternalLinkAlt size={16} />
                                                    </button>

                                                    <span className="border border-secondary-600 h-5"></span>

                                                    <span>{item.title}</span>
                                                </div>
                                            </td>

                                            <td className="px-5 py-4 text-center border">
                                                <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-green-100 text-green-700 font-semibold">
                                                    {item.profileCount}
                                                </span>
                                            </td>

                                            {status?.map((sts) => (
                                                <td
                                                    key={sts._id}
                                                    className="px-5 py-4 text-center border"
                                                >
                                                    <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-semibold">
                                                        {item.statusCounts?.[sts.status.toLowerCase()]?.count || 0}
                                                    </span>

                                                    {item.statusCounts?.[sts.status.toLowerCase()]?.duplicate > 0 && (
                                                        <div className="text-xs text-red-600 font-semibold mt-1">
                                                            +{item.statusCounts[sts.status.toLowerCase()].duplicate}
                                                        </div>
                                                    )}
                                                </td>
                                            ))}

                                            <td className="px-5 py-4 text-center border">
                                                {item?.totalStatusCount}
                                            </td>
                                            <td className="px-5 py-4 text-center border">
                                                {item?.difference}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={status.length + 5}
                                            className="py-12 text-center text-gray-500"
                                        >
                                            No reports found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-5 px-6 py-4 bg-white border-t">

                        {/* Showing Records */}
                        <div className="text-sm text-gray-600">
                            Showing{" "}
                            <span className="font-semibold text-primary-600">
                                {startRecord}
                            </span>
                            {" - "}
                            <span className="font-semibold text-primary-600">
                                {endRecord}
                            </span>
                            {" "}of{" "}
                            <span className="font-semibold text-primary-600">
                                {data?.pagination?.total || 0}
                            </span>{" "}
                            Positions
                        </div>

                        <div className="flex flex-wrap items-center gap-5">

                            {/* Rows Per Page */}
                            <div className="flex items-center gap-2">
                                <span className="text-sm text-gray-600">
                                    Rows per page
                                </span>

                                <select
                                    value={limit}
                                    onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setPage(1);
                                    }}
                                    disabled={loading}
                                    className="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 outline-none disabled:opacity-50"
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Pagination */}
                            <div className="flex items-center gap-2">

                                {/* First */}
                                <button
                                    onClick={goToFirst}
                                    disabled={page === 1 || loading}
                                    className="px-3 py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-40"
                                >
                                    ⏮
                                </button>

                                {/* Previous */}
                                <button
                                    onClick={goToPrevious}
                                    disabled={page === 1 || loading}
                                    className="px-3 py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-40"
                                >
                                    ◀
                                </button>

                                {/* Page Numbers */}
                                {getPageNumbers().map((item, index) =>
                                    item === "..." ? (
                                        <span
                                            key={`dots-${index}`}
                                            className="px-2 text-gray-500"
                                        >
                                            ...
                                        </span>
                                    ) : (
                                        <button
                                            key={`page-${item}`}
                                            onClick={() => setPage(item)}
                                            disabled={loading}
                                            className={`w-10 h-10 rounded-lg font-semibold transition
                                             ${page === item
                                                    ? "bg-primary-600 text-white shadow-lg"
                                                    : "border bg-white hover:bg-primary-50"
                                                }`}
                                        >
                                            {item}
                                        </button>
                                    )
                                )}

                                {/* Next */}
                                <button
                                    onClick={goToNext}
                                    disabled={page === totalPages || loading}
                                    className="px-3 py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-40"
                                >
                                    ▶
                                </button>

                                {/* Last */}
                                <button
                                    onClick={goToLast}
                                    disabled={page === totalPages || loading}
                                    className="px-3 py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-40"
                                >
                                    ⏭
                                </button>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};
